import React, { Suspense } from "react";
import { Tabs, TabsHeader, TabsBody, Tab, TabPanel } from "@material-tailwind/react";
import { useSearchParams } from "react-router-dom";

interface projectDetailPageTabsProps {
  title: string;
  value: string;
  content?: React.ReactNode | string;
}

interface ProjectTabsProps {
  projectDetailPageTabs: projectDetailPageTabsProps[];
}

const ProjectTabs = ({ projectDetailPageTabs }: ProjectTabsProps) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get("tab") ?? projectDetailPageTabs[0].value;

  return (
    <Tabs value={activeTab} className="w-full">
      <TabsHeader
        placeholder=""
        className="text-nowrap rounded-none border-b border-blue-gray-50 bg-transparent p-0 font-primary text-sm"
        indicatorProps={{
          className: "bg-transparent border-b-2 border-primaryPurple-100 shadow-none rounded-none",
        }}
      >
        {projectDetailPageTabs.map(({ title, value }) => (
          <Tab
            placeholder=""
            key={value}
            value={value}
            onClick={() =>
              setSearchParams((prev) => {
                prev.set("tab", value);
                return prev;
              })
            }
            className={`${
              activeTab === value ? "font-semibold" : "font-light text-gray-900"
            } font-primary text-base`}
          >
            {title}
          </Tab>
        ))}
      </TabsHeader>
      <TabsBody placeholder="" className="w-full">
        {projectDetailPageTabs
          .filter(({ value }) => value === activeTab)
          .map(({ value, content }) => (
            <TabPanel key={value} value={value} className="font-primary text-black">
              <Suspense fallback={<></>}>{content}</Suspense>
            </TabPanel>
          ))}
      </TabsBody>
    </Tabs>
  );
};

export default ProjectTabs;
